import type { Messages } from "./fr";

export const en: Messages = {
  appName: "Beach Pop",
  install: "Install",
  privateBetaNotice:
    "Private beta — for testing only. Install only from the official link provided by MaxNova Studio.",
  languageName: "English",
  menu: {
    play: "Play",
    nickname: "Nickname",
    nicknamePlaceholder: "Your beach name",
    character: "Character",
    customize: "Customize",
    difficulty: "Difficulty",
    easy: "Easy",
    normal: "Normal",
    hard: "Hard",
    lives: "lives",
    balloons: "max balloons",
    settings: "Settings",
    instructions: "Instructions",
    highScores: "High scores",
    options: "Options",
    language: "Language",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
  },
  character: {
    title: "Customize",
    girl: "Girl",
    boy: "Boy",
    skin: "Skin",
    hair: "Hair",
    outfit: "Outfit",
    save: "Save",
    back: "Back",
    preview: "Preview",
  },
  instructions: {
    title: "How to play",
    p1: "Hold to aim, release to throw a frisbee in a straight line. Power is fixed.",
    p2: "You have three frisbees. A miss removes one and resets the combo. A hit restores all three.",
    p3: "Balloons rise then fall. If they hit the sand, you lose a life. The golden balloon enables piercing frisbees for 10 seconds.",
    p4: "Easy: 10 lives and 1 balloon. Normal: 5 lives and 2 balloons. Hard: 3 lives and 3 balloons. The run is endless: speed rises until 10,000 points.",
    start: "Continue",
    skipTutorial: "Skip tutorial",
    playTutorial: "Play tutorial",
    back: "Back",
  },
  tutorial: {
    skip: "Skip",
    next: "Got it",
    aim: "Hold to aim at the balloon. A dashed line shows the direction.",
    throw: "Release to throw. The path is straight.",
    ammo: "You have three frisbees. A shot that misses removes one.",
    reload: "Hit a balloon to instantly restore all three frisbees.",
    lives: "If a balloon touches the sand, a heart disappears.",
    combo: "Each success increases the combo and multiplies points.",
    gold: "The golden balloon activates a piercing power for 10 seconds.",
    done: "You are ready. Have fun on the beach!",
  },
  hud: {
    score: "Score",
    combo: "Combo",
    power: "Golden power",
    pause: "Pause",
  },
  pause: {
    title: "Paused",
    resume: "Resume",
    restart: "Restart",
    help: "Help",
    music: "Music",
    ambient: "Ambience",
    sfx: "Sound effects",
    accessibility: "Accessibility",
    fullscreen: "Fullscreen",
    menu: "Main menu",
  },
  countdown: "Get ready",
  gameover: {
    title: "Game over",
    cheerRecord: "New beach record!",
    cheerGreat: "A spectacular point wave!",
    cheerGood: "Sunny streak — well thrown!",
    cheerOk: "The next wave will be yours!",
    noLives: "No lives left",
    noFrisbees: "No frisbees left",
    score: "Final score",
    bestCombo: "Best combo",
    popped: "Balloons popped",
    shots: "Shots taken",
    hits: "Successful shots",
    accuracy: "Accuracy",
    newRecord: "New record!",
    replay: "Play again",
    menu: "Main menu",
    board: "Best scores",
    boardEasy: "Best scores — Easy",
    boardNormal: "Best scores — Normal",
    boardHard: "Best scores — Hard",
    changeDifficulty: "Change difficulty",
    chooseDifficulty: "Choose a difficulty",
  },
  scores: {
    title: "High scores",
    empty: "No scores for this mode yet.",
    back: "Back",
    date: "Date",
  },
  options: {
    title: "Settings",
    shake: "Screen shake",
    textSize: "Text size",
    reduceMotion: "Reduce motion",
    highContrast: "High contrast",
    colorAssist: "Color distinction",
    aimLength: "Aim line length",
    clearScores: "Clear leaderboards",
    resetAll: "Reset all data",
    confirmClear: "Clear the top five scores for every mode?",
    confirmReset: "Reset language, character, options, and leaderboards?",
    yes: "Yes, delete",
    no: "Cancel",
    back: "Back",
    cleared: "Leaderboards cleared.",
    resetDone: "All data has been reset.",
    replayTutorial: "Replay tutorial",
    langHint: "Choose the interface language.",
    fullscreenHint: "Show the game in fullscreen.",
    installHint: "Add Beach Pop to this device.",
    installInstalled: "Already installed",
    installInstalledHint: "Beach Pop is open as an app on this device.",
    installUnavailable: "Install unavailable",
    installUnsupported: "This browser cannot install the app. On iPhone, use Share, then Add to Home Screen.",
    tutorialHint: "Replay the guided steps.",
    instructionsHint: "Read how to play.",
    tabSound: "Sound",
    tabAccess: "Accessibility",
    tabGeneral: "General",
    tabHelp: "Help",
    tabScores: "High scores",
    tabData: "Data",
  },
  rotate: {
    title: "Rotate your device",
    message: "Beach Pop is played in landscape only.",
  },
  help: {
    title: "Help",
    body: "Hold to aim, release to throw. A miss removes a frisbee. A hit reloads all three. A balloon on the sand removes a life. Gold pierces for 10 seconds. The game pauses if the tab is hidden.",
    close: "Close",
  },
};
